import { sanitizeMapFilename } from './filename.ts';
import type { MapDocument } from './types.ts';

export const MAX_MAP_NAME_LENGTH = 80;

/** Display title stored on the document. Spaces and punctuation are fine; the file stem is separate. */
export function sanitizeMapName(raw: string): string {
  return raw
    .replace(/[\u0000-\u001f\u007f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_MAP_NAME_LENGTH);
}

export function setMapName(map: MapDocument, raw: string): void {
  map.name = sanitizeMapName(raw);
}

export function mapDisplayName(name: string, fallback = 'Untitled'): string {
  return name.trim() || fallback;
}

/** Catalog / menubar fallback when `name` is empty: `one-stone` → `One Stone`. */
export function labelFromFilename(fileName: string): string {
  const stem = fileName.replace(/\.json$/i, '');

  if (!stem || stem === 'Untitled') {
    return '';
  }

  return stem.replace(/[-_]+/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}

/** Turns a title into a catalog basename, or null if nothing safe remains. */
export function suggestMapFilename(raw: string): string | null {
  const slug = sanitizeMapName(raw)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 128);

  return slug ? sanitizeMapFilename(slug) : null;
}
